import React from 'react';
import SpotlightBodyText from './SpotlightBodyText';
import SpotlightTwoPhotoMedium from './SpotlightTwoPhotoMedium';
import SpotlightInlineImage from './SpotlightInlineImage';
import SpotlightFeaturedProducts from './SpotlightFeaturedProducts';
import SpotlightExternalVideo from './SpotlightExternalVideo';

export default ({ components = [] }) => {

  return (
    <React.Fragment>
      {components &&
        components.map((component, index) => {
          switch (component._type) {
            case 'spotlightTwoPhotoMedium':
              return (
                <SpotlightTwoPhotoMedium
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            case 'spotlightBodyText':
              return (
                <SpotlightBodyText
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            case 'spotlightInlinePhoto':
              return (
                <SpotlightInlineImage
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            case 'spotlightFeaturedProducts':
              return (
                <SpotlightFeaturedProducts
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            case 'spotlightExternalVideo':
              return (
                <SpotlightExternalVideo
                  index={index}
                  key={component._key}
                  {...component}
                />
              );
            default:
              return null;
          }
        })}
    </React.Fragment>
  );
};
